





































































































































































































import { Component, Vue } from "vue-property-decorator";
import * as firebaseui from "firebaseui";
import * as firebase from "firebase/app";
import "firebase/auth";

@Component({
  components: {}
})
export default class Login extends Vue {
  firebaseUiConfig: any;
  ui: any;

  constructor(props: any) {
    super(props);

    this.firebaseUiConfig = {
      signInSuccessUrl: "/feed",
      signInOptions: [
        // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        firebase.auth.GoogleAuthProvider.PROVIDER_ID
      ],
      signInFlow: "redirect",
      // Terms of service url/callback.
      tosUrl: "https://atlis.io/terms",
      // Privacy policy url/callback.
      privacyPolicyUrl: "https://atlis.io/privacy"
    };

    // Initialize the FirebaseUI Widget using Firebase.
    this.ui =
      firebaseui.auth.AuthUI.getInstance() ||
      new firebaseui.auth.AuthUI(firebase.auth());
  }

  mounted() {
    // The start method will wait until the DOM is loaded.
    this.ui.start("#firebaseui-auth-container", this.firebaseUiConfig);
  }
}
